import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  error: boolean;
  message: string;
  email: string;
  signoutReason: string;
};

const initialState: StateInterface = {
  isFetching: false,
  error: true,
  message: "",
  email: "",
  signoutReason: ""
};

export const checkEmailReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CHECK_EMAIL_UPDATE_EMAIL:
      return {
        ...state,
        email: action.payload?.email
      };

    case Constants.PAGE_CHECK_EMAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false
      };

    case Constants.PAGE_CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.PAGE_CHECK_EMAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        message: action.payload?.err.translatedMessage,
        error: true
      };

    case Constants.PAGE_CHECK_EMAIL_ADD_SIGNOUT_REASON:
      return {
        ...state,
        signoutReason: action.payload?.signoutReason
      };

    case Constants.PAGE_CHECK_EMAIL_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState,
        signoutReason: state.signoutReason
      };

    default:
      return state;
  }
};
